import { SortBy, SortOrder } from "@coveo/headless";

export const sortingOptions = [
    {
        labelKey: 'SORTING.RELEVANCY',
        sortBy: SortBy.Relevancy,
        sortOrder: '',
        sortField: '',
    },
    {
        labelKey: 'SORTING.NEWEST',
        sortBy: SortBy.Date,
        sortOrder: SortOrder.Descending,
        sortField: 'onlinefrom',
    },
    {
        labelKey: 'SORTING.OLDEST',
        sortBy: SortBy.Date,
        sortOrder: SortOrder.Ascending,
        sortField: 'onlinefrom',
    },
    {
        labelKey: 'SORTING.ALPHABETICAL',
        sortBy: SortBy.Field,
        sortOrder: SortOrder.Ascending,
        sortField: 'shortname',
    },
    {
        labelKey: 'SORTING.PRICE_ASCENDING',
        sortBy: SortBy.Field,
        sortOrder: SortOrder.Ascending,
        sortField: 'price_discounted',
    },
    {
        labelKey: 'SORTING.PRICE_DESCENDING',
        sortBy: SortBy.Field,
        sortOrder: SortOrder.Descending,
        sortField: 'price_discounted',
    },
];
